import React from "react";
import Menu from "./Menu";
import {getProvider} from "./Provider"
import {ethers,utils} from "ethers"
// components
import HeaderStats from "components/Headers/HeaderStats.js";
import { SpinnerCircular } from 'spinners-react';

import { useState  } from "react";

export default function Dashboard() {
 

  const [staking,setStake]=useState('');
  const[spinner,setspinner]=useState(false);
  const[Unstakespinner,setUnstakespinner]=useState(false);
  const[Approverspinner,setApproverspinner]=useState(false);
  const[Stakerspinner,setStakerspinner]=useState(false);
  const abi = [
    "function earned(address account) view returns (uint256)",
    "function withdraw()",
    "function stake(uint256 _amount)"
  ];
  // if(!window.ethereum){
  //   alert("Use a DAPP Browser")
  // }

 



  
  async function withdraw() {
    const provider = await getProvider()
    const signer = provider.getSigner()
    // if (typeof window.ethereum !== 'undefined'){
    //   await reqAcct();
    const contract = new ethers.Contract(address, abi, signer);   
    const tx = await contract.functions.withdraw();
  
    const receipt = await tx.wait();
    console.log("receipt", receipt);
    // }
  }
 
  let totalStaking=staking*1000000000000000000;
async function approve() {
  const provider = await getProvider()
  const signer = provider.getSigner()
  const Tokenabi = [
    "function approve(address spender, uint256 amount) returns (bool)"
  ];
	const contract = new ethers.Contract("0x6364c250a26f171e05b9D26b66baB17921eC72b9", Tokenabi, signer);   
	const tx = await contract.functions.approve("0x387d19322826A02d60a3ce6934DA144378EBfF85",totalStaking.toString());
  

	const receipt = await tx.wait();
	console.log("receipt", receipt);
}





 
 
  const address = "0x387d19322826A02d60a3ce6934DA144378EBfF85";
 


async function stake() {
  const provider = await getProvider()
  const signer = provider.getSigner()
  // if (typeof window.ethereum !== 'undefined'){
  //   await reqAcct();
	const contract = new ethers.Contract(address, abi, signer);   
	const tx = await contract.functions.stake(totalStaking.toString());

	const receipt = await tx.wait();
	console.log("receipt", receipt);
  // }
}

 function staker(){
  setStakerspinner(true)
  stake().then(function(value) {
    console.log(value); // "Success!"
    alert("Staking SuccesFull")
    throw "oh, no!";
  }).catch(function(e) {
    setStakerspinner(false)
    //alert("Staking UnSuccesFull")
    console.log(e); // "oh, no!"
  });

}
function unstaker(){
  setUnstakespinner(true)
  withdraw().then(function(value) {
    console.log(value); // "Success!"
    alert("UnStaking SuccesFull")
    throw "oh, no!";
  }).catch(function(e) {
    setUnstakespinner(false)
  //  alert("UnStaking Error")
    console.log(e); // "oh, no!"
  });
  

}
function approver(){
  console.log(utils.parseEther("1.0"));
  setApproverspinner(true)
  approve().then(function(value) {
  //  console.log(value); // "Success!"
    alert("Approval SuccessFull")
    throw "oh, no!";
  }).catch(function(e) {
    setApproverspinner(false)
    //alert("Approval Error")
   // console.log(e); // "oh, no!"
  });

}

// stake();



  return (
    <>
    {/* <Menu/> */}
      <HeaderStats />
       <div className=" mt-20 my-Font">
       <div className="w-full lg:w-1/3 py-6 xl:w-1/3 px-4">
              <label className="text-xl" style={{
                paddingBottom:"20px"
              }}>
                Amount to Stake
                
                </label>
              <div class="mb-3 pt-0">
  <input type="text" placeholder="Amount to Stake" onChange={(e)=>setStake(e.target.value)} class="px-3 py-4 placeholder-blueGray-300 text-blueGray-600 relative  bg-white rounded text-base border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"/>
</div>
<div className="flex flex-col">
           <span>
            Approve Before Staking 
          </span>
          <div className="flex flex-row items-center pt-12   ">
          <button onClick={staker} className="rounded-full py-4  px-12 bg-white text-xl ">
              Stake
          </button>
          <SpinnerCircular enabled={Stakerspinner} />
          &nbsp;&nbsp;&nbsp;
          <button onClick={approver} className="rounded-full py-4  ml-1 px-12 bg-white text-xl">
          Approve
          </button>
          <SpinnerCircular enabled={Approverspinner} />
          <br/>



          </div>
         
         

</div>

              </div>
        <div className="pb-10">
         
         
        </div>
        <div className="w-full lg:w-1/3 py-6 xl:w-1/3 px-4">
<button onClick={unstaker} className="rounded-full py-4 mr-10 px-12 bg-white text-2xl mb-20">
              Unstake
          </button>
          <SpinnerCircular enabled={Unstakespinner} />
              </div>
     
       
       </div>
    </>
  );
}
